// extracted by mini-css-extract-plugin
export default {"disabled":"AJ2I9FFAzIaJbxpsiBE0","variantDefault":"Vu5RoAMMH_jMU_bMrF1n","variantPrimary":"f6GJkMafmsVb1dIJt1xA"};